<template>
  <div class="bookDirectory-container">
    <div class="bookDirectory-main">
      <div class="bookDirectory-content" v-bar>
        <div>
          <el-card class="bookDirectory-card" :body-style="{ padding: '20px' }">
            <div class="custom-tree-container">
              <div class="directoryCtl">
                <div class="leftCtl">
                  {{ $t("content.books.chapter") }}
                </div>
                <div class="rightCtl">
                  <button class="global-button-style" @click="addSection">
                    {{ $t("content.books.addChapter") }}
                  </button>
                </div>
              </div>
              <div class="block">
                <el-tree
                  :data="data"
                  node-key="id"
                  default-expand-all
                  :props="defaultProps"
                  :expand-on-click-node="false"
                >
                  <div class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ data.name }}</span>
                    <span class="sectionCtl">
                      <el-button
                        type="text"
                        size="mini"
                        @click="() => append(data)"
                        v-if="data.level !== 2"
                      >
                        {{ $t("content.books.addSection") }}
                      </el-button>

                      <el-button
                        type="text"
                        size="mini"
                        @click="() => modification(node, data)"
                      >
                        {{ $t("commonMsg.rename") }}
                      </el-button>
                      <el-button
                        type="text"
                        size="mini"
                        @click="() => remove(node, data)"
                      >
                        {{ $t("commonMsg.del") }}
                      </el-button>
                    </span>
                  </div>
                </el-tree>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>

    <transition-group name="fade">
      <DelPopup key="h" @deleteHandle="deleteHandle" v-if="delPopup" />
      <AddComponent
        key="addComponent"
        v-if="addPopup"
        :title="addPopupTitle"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @addEvn="addEvn"
      />
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DelPopup from "@/components/delPopup";
import AddComponent from "./addPopup";

export default {
  props: ["booksId"],
  computed: {
    ...mapGetters(["delPopup", "addPopup"]),
    ruleProps() {
      let ruleProps = [
        {
          prop: "name",
          type: "textarea",
          label: this.$t("content.books.chapterName"),
          placeholder: this.$t("placeholder.name"),
        },
      ];
      return ruleProps;
    },
    rules() {
      let rules = {
        name: [
          {
            required: true,
            message: this.$t("verify.groupName"),
            trigger: "blur",
          },
        ],
      };
      return rules;
    },
  },
  components: {
    AddComponent,
    DelPopup,
  },
  data() {
    return {
      data: [],
      bookId: this.$route.query.bookId
        ? this.$route.query.bookId
        : this.booksId,
      //            表单需要提交的
      ruleForm: {
        name: "",
      },
      addPopupTitle: "",
      defaultProps: {
        children: "sub_chapter",
        label: "name",
      },
    };
  },

  methods: {
    addEvn(data) {
      if (this.addPopupTitle === this.$t("content.books.addChapter")) {
        let Ojs = {
          name: data.name,
          point: "",
          level: "1",
          bookId: this.bookId,
        };
        this.$http
          .chaptersBooks(Ojs)
          .then((res) => {
            this.getChaptersBooks();
            this.elMsg(this.$t("alertMsg.addSuccess"), "success");
            this.$store.commit("windowHandle");
          })
          .catch((err) => {});
      } else if (this.addPopupTitle === this.$t("content.books.addSection")) {
        let Ojs = {
          name: data.name,
          id: this.appendData.id,
          level: "2",
          point: "",
          bookId: this.bookId,
        };
        this.$http
          .chaptersBooks(Ojs)
          .then((res) => {
            this.getChaptersBooks();
            this.elMsg(this.$t("alertMsg.addSuccess"), "success");
            this.$store.commit("windowHandle");
          })
          .catch((err) => {});
      } else {
        this.modificationData.label = data.name;
        this.$http
          .editChaptersBooks(this.booksId, data.name)
          .then((res) => {
            this.getChaptersBooks();
            this.elMsg(this.$t("alertMsg.modifySuccess"), "success");
            this.$store.commit("windowHandle");
          })
          .catch((err) => {});
      }
    },
    deleteHandle() {
      const parent = this.node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex((d) => d.id === this.removeData.id);
      children.splice(index, 1);
      this.$http
        .deleteBooks(this.removeData.id)
        .then((res) => {
          this.getChaptersBooks();
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
        })
        .catch(() => {});
    },
    remove(node, data) {
      this.$store.commit("windowHandle", "delPopup");
      this.node = node;
      this.removeData = data;
    },
    modification(node, data) {
      this.addPopupTitle = this.$t("content.books.rename");
      this.$store.commit("windowHandle", "addPopup");
      this.modificationData = data;
    },
    addSection(data) {
      if (!this.bookId) {
        this.elMsg("请先上传书籍", "warning");
        return;
      }
      this.addPopupTitle = this.$t("content.books.addChapter");
      this.$store.commit("windowHandle", "addPopup");
    },
    append(data) {
      this.appendData = data;
      this.addPopupTitle = this.$t("content.books.addSection");
      this.$store.commit("windowHandle", "addPopup");
    },
    getChaptersBooks() {
      this.$http.getChaptersBooks(this.bookId).then((res) => {
        this.data = res.data;
      });
    },
    // renderContent(h, { node, data, store }) {
    //     return (
    //         <span class="custom-tree-node">
    //         <span>{node.label}</span>
    //     <span>
    //     <el-button size="mini" type="text" on-click={ () => this.append(data) }>添加</el-button>
    //     <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>{{$t('commonMsg.del')}}</el-button>
    //     <el-button size="mini" type="text" on-click={ () => this.modification(node, data) }>修改</el-button>
    //     </span>
    //     </span>);
    // }
  },
  watch: {
    booksId(val) {
      val ? (this.bookId = val) : "";
    },
  },
  async mounted() {
    await this.getChaptersBooks();
  },
};
</script>

<style lang="scss" scoped>
.bookDirectory-container {
  flex: 1;
  overflow: hidden;
  > .bookDirectory-main {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .bookDirectory-content {
      overflow: hidden;
      flex: 1;
      .bookDirectory-card {
        margin: 20px;
      }
    }
  }
}

/*内容样式*/
.directoryCtl {
  display: flex;
  line-height: 40px;
  margin-bottom: 10px;
  justify-content: space-between; /*此处修改成不同值*/
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
